import React, { useContext, useState } from 'react';
import { CheckboxGroup, Checkbox } from 'chaoskit/src/components';

import {
  ReliabilityHelp,
  ReliabilityHelpTrigger,
  ReliabilityInput,
} from '../../pages/reliability-calculator';
import { ReliabilityCalculatorContext } from './Context';

const Step2 = () => {
  const {
    state: { step2 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext);
  const [helpOpen, toggleHelpOpen] = useState(false);
  const [disableInput, setDisableInput] = useState(false);

  return (
    <div className="reliabilityCalculator__cell">
      {helpOpen ? (
        <ReliabilityHelp
          title="Mean time between failure"
          toggleHelpOpen={toggleHelpOpen}
        >
          <p>
            Mean time between failure (MTBF) describes the average amount of
            time between incidents for a given service.
          </p>
          <p>Take this simple example:</p>
          <p>
            In a given month, Service A has an incident on Day 5, Day 17, and
            Day 25. The time between failures in hours is:
            <br />
            (17 - 5) x 24 = 288
            <br />
            (25 - 17) x 24 = 192
          </p>
          <p>
            The mean time between failures is therefore:
            <br />
            288 + 192 / 2 = 240
          </p>
          <p>
            You can estimate your MTBF by dividing the number of hours in a
            month or year by the number of incidents within the same period.
          </p>
          <p>
            For example, if you had 6 incidents last year, your MTBF is
            approximately 1,460 hours.
          </p>
        </ReliabilityHelp>
      ) : (
        <div className="hero-titleWrapper u-contrast">
          <h1 className="hero-title">
            What is the{' '}
            <ReliabilityHelpTrigger onClick={() => toggleHelpOpen(!helpOpen)}>
              mean time between failure
            </ReliabilityHelpTrigger>{' '}
            (MTBF) for this service?
          </h1>
        </div>
      )}
      <ReliabilityInput
        name="mtbf-input"
        onChange={(name, value) =>
          dispatch({
            type: 'choice',
            payload: {
              step2: value,
            },
          })
        }
        disabled={disableInput}
        value={step2}
        explanationMessage="Measured in hours"
      />
      <CheckboxGroup className="reliabilityCalculator__checkbox u-contrast">
        <Checkbox
          name="mtbf-checkbox"
          onChange={(name, value, checked) => {
            if (checked) {
              dispatch({
                type: 'choice',
                payload: {
                  step2: 0,
                },
              });
            }

            setDisableInput(checked);
          }}
          label="We don’t currently measure MTBF"
          value="0"
        />
      </CheckboxGroup>
    </div>
  );
};

export default Step2;
